function BackgroundGradient() {
  return (
    <div className="tailwind-scope">
      <div className="fixed top-0 z-[-2] min-h-screen w-screen bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,#dad7f6,rgba(176,196,222,0.08))]"></div>
    </div>
  );
}

export default BackgroundGradient;
